import { NextSeo } from 'next-seo';

//screens
import { DetentionHandling } from '@/screens/Agents/DetentionHandling';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function DetentionHandlingPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/detention-handling/"
        title="Detention Handling Agent | Loadsmart AI"
        description="Warns the dock before a truck runs past its free time, reports the detention you owe, and approves a carrier’s detention request when it matches the gate record."
        openGraph={{
          url: 'https://loadsmart.com/ai/detention-handling/',
        }}
      />
      <JsonLd data={Organization} />
      <DetentionHandling />
    </>
  );
}
